import { IconTrash, IconUserOff } from "@tabler/icons-react";
import { useState } from "react";
import { api, ApiError } from "../api";
import { Footer } from "../components/Footer";
import { ErrorNote } from "../components/ui";
import { useSession } from "../session";

/**
 * docs/16 §6: the link in the deletion email lands here, signed in or not. One red button confirms; the API erases the
 * area's copy and clears the session cookie, so the page only has to forget the local session.
 */
export function DeleteConfirmPage({ token }: { token: string }) {
  const { setMe, t } = useSession();
  const [state, setState] = useState<"idle" | "busy" | "done" | "expired" | "error">("idle");

  const confirm = async () => {
    setState("busy");
    try {
      await api.confirmDeletion(token);
      setMe(null);
      setState("done");
    } catch (err) {
      setState(err instanceof ApiError && err.status === 410 ? "expired" : "error");
    }
  };

  return (
    <div className="page page-center">
      <main className="centered">
        {state === "done" ? (
          <>
            <IconUserOff size={40} stroke={1.25} className="muted" />
            <h1>{t("deleteDone")}</h1>
            <p className="muted">{t("deleteDoneBody")}</p>
            <a href="/signin" className="button">
              {t("signIn")}
            </a>
          </>
        ) : state === "expired" ? (
          <>
            <IconTrash size={40} stroke={1.25} className="muted" />
            <h1>{t("deleteConfirmTitle")}</h1>
            <p className="muted">{t("deleteLinkExpired")}</p>
            <a href="/" className="button button-primary">
              {t("goHome")}
            </a>
          </>
        ) : (
          <>
            <IconTrash size={40} stroke={1.25} className="muted" />
            <h1>{t("deleteConfirmTitle")}</h1>
            <p className="muted">{t("deleteConfirmBody")}</p>
            {state === "error" && <ErrorNote>{t("somethingWrong")}</ErrorNote>}
            <button type="button" className="button button-danger" onClick={() => void confirm()} disabled={state === "busy"}>
              <IconTrash size={18} /> {state === "busy" ? t("deleting") : t("deleteForGood")}
            </button>
            <a href="/" className="link-button">
              {t("keepAccount")}
            </a>
          </>
        )}
      </main>
      <Footer />
    </div>
  );
}
